import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginPage } from './login.page';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { LoginRoutingModule } from './login-routing.module';
import { AccesoModule } from './_components/acceso/acceso.module';
import { RestablecerContrasenaModule } from './_components/restablecer-contrasena/restablecer-contrasena.module';
import { InicioFactorModule } from './_components/inicio-factor/inicio-factor.module';

@NgModule({
  declarations: [LoginPage],
  imports: [
    CommonModule,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    FormsModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    AccesoModule,
    RestablecerContrasenaModule,
    InicioFactorModule
  ],
  exports: [LoginPage],
})
export class LoginModule {}
